import { Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES } from '../i18n/config'

/**
 * Language picker dropdown. Persists choice via the i18n
 * LanguageDetector's localStorage cache (key "vynahealth-language"),
 * so the same language survives reloads and page navigation.
 *
 * Used on the login page (alongside ThemeToggle) and in the
 * authenticated TopBar. Keep it accessible: the <select> gets the
 * visible label via aria-label, and the icon is purely decorative.
 */
export default function LanguageSwitcher() {
  const { i18n } = useTranslation()

  return (
    <label className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
      <Languages className="h-4 w-4 shrink-0" aria-hidden="true" />
      <select
        value={i18n.resolvedLanguage ?? i18n.language}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value)
        }}
        aria-label="Select language"
        className="bg-transparent text-sm focus:outline-hidden cursor-pointer"
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code} className="bg-background text-foreground">
            {lang.label}
          </option>
        ))}
      </select>
    </label>
  )
}
